const CartIconNmuk = () => import('./components/CartIcon');
Vue.component('CartIconNmuk', CartIconNmuk);

const ProductImages = () => import('./components/ProductImages');
Vue.component('ProductImages', ProductImages);

const MobileMenu = () => import('./components/Menu');
Vue.component('MobileMenu', MobileMenu);

const Tracking = () => import('./components/Tracking');
Vue.component('Tracking', Tracking);

const TrackingMap = () => import('./components/TrackingMap');
Vue.component('TrackingMap', TrackingMap);

const MenuToggle = () => import('./components/MenuToggle');
Vue.component('MenuToggle', MenuToggle);

const Accordion = () => import('./components/Accordion');
Vue.component('Accordion', Accordion);

const Banner = () => import('./components/Banner');
Vue.component('Banner', Banner);

const Experts = () => import('./components/Experts');
Vue.component('Experts', Experts);

const Videos = () => import('./components/Videos');
Vue.component('Videos', Videos);

const ProductSlider = () => import('./components/Slider');
Vue.component('ProductSlider', ProductSlider);

const HomepageProduct = () => import('./components/HomepageProduct');
Vue.component('HomepageProduct', HomepageProduct);

const SurveyMonkey = () => import('./components/SurveyMonkey');
Vue.component('SurveyMonkey', SurveyMonkey);

const RecommendedProducts = () => import('./components/RecommendedProducts');
Vue.component('RecommendedProducts',  RecommendedProducts);

const HeaderTextCarousel = () => import('./components/HeaderTextCarousel');
Vue.component('HeaderTextCarousel',  HeaderTextCarousel);

const CarouselRepeatLastOrder = () => import('./components/CarouselRepeatLastOrder');
Vue.component('CarouselRepeatLastOrder', CarouselRepeatLastOrder);
